import React from 'react';
import { KeyValueItem } from '@gerdau/hefesto-mais-web';
import { Skeleton, Title } from '@gerdau/hefesto';
import { IFabricationContract } from '../../../../../store/ducks/fabrication-contracts/types';
import { uppercaseOnlyFirstLetter } from '../../../../../utils/formatStrings';
import {
  ConstructionAddressContainer,
  ConstructionAddressItem
} from './styles';
import { WhiteBlockContainer } from '../styles';

interface IConstructionAddressContentProps {
  loading: boolean;
  contract?: IFabricationContract;
}

const ConstructionAddressContent: React.FC<
  IConstructionAddressContentProps
> = ({ loading, contract }) => {
  return (
    <WhiteBlockContainer>
      <Title level={2}>Endereço da obra</Title>

      <ConstructionAddressContainer>
        <ConstructionAddressItem>
          <KeyValueItem title={'CEP'}>
            {loading ? (
              <Skeleton type="title" />
            ) : (
              contract?.shipTo.zipCode || '-'
            )}
          </KeyValueItem>
        </ConstructionAddressItem>
        <ConstructionAddressItem>
          <KeyValueItem title={'Rua'}>
            {loading ? (
              <Skeleton type="title" />
            ) : contract && contract.shipTo.address ? (
              uppercaseOnlyFirstLetter(contract.shipTo.address)
            ) : (
              '-'
            )}
          </KeyValueItem>
        </ConstructionAddressItem>
        <ConstructionAddressItem>
          <KeyValueItem title={'Estado'}>
            {loading ? (
              <Skeleton type="title" />
            ) : (
              contract?.shipTo.state || '-'
            )}
          </KeyValueItem>
        </ConstructionAddressItem>
        <ConstructionAddressItem>
          <KeyValueItem title={'Cidade'}>
            {loading ? (
              <Skeleton type="title" />
            ) : contract && contract.shipTo.address ? (
              uppercaseOnlyFirstLetter(contract.shipTo.city || '')
            ) : (
              '-'
            )}
          </KeyValueItem>
        </ConstructionAddressItem>
      </ConstructionAddressContainer>
    </WhiteBlockContainer>
  );
};

export default ConstructionAddressContent;
